import React from 'react';
import TableSettingsView from '../../../../../shared/TableSettings/TableSettingsView';
import { EntityType } from '../../../../../../types/comment';
import { CustomFieldEntityType } from '../../../../../../types/custom_field';
import { translate } from '../../../../../../types/translation/Translator';
import { TranslationKey } from '../../../../../../types/translation/TranslationKey';
import { ProductTableSettingsColumn } from '../../../../../../types/table_settings/product/ProductTableSettings';

export default function ProductTableSettingsPane() {
  return (
    <div className='content-x'>
      <TableSettingsView<ProductTableSettingsColumn>
        type={EntityType.product}
        customFieldEntityType={CustomFieldEntityType.product}
        availableColumns={Object.values(ProductTableSettingsColumn)}
        columnTextBuilder={item => translate({ key: item })}
        label={translate({ key: TranslationKey.addProductColumn })}
        placeholder={translate({ key: TranslationKey.addProductColumn })}
      />
    </div>
  );
}
